import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_HEIGHT = 36;
var EditableText = function EditableText(_ref) {
  var disabled = _ref.disabled,
    required = _ref.required,
    unfocusable = _ref.unfocusable,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    value = _ref.value,
    large = _ref.large,
    editing = _ref.editing,
    inverted = _ref.inverted,
    placeholder = _ref.placeholder,
    invisible = _ref.invisible;
  var ref = useRef();
  var _useState = useState(DEFAULT_HEIGHT),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    valueState = _useState6[0],
    setValue = _useState6[1];
  var resize = function resize() {
    var _ref$current;
    if (ref.current && typeof ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollHeight) != 'undefined') {
      var isHeightDifferent = Math.abs(ref.current.scrollHeight - height) > 2;
      if (isHeightDifferent && ref.current.scrollHeight > DEFAULT_HEIGHT) {
        setHeight(ref.current.scrollHeight);
      }
    }
  };
  useEffect(function () {
    resize();
  }, [value]);
  var onFocusSelf = function onFocusSelf() {
    setFocused(true);
    if (onFocus) {
      onFocus();
    }
  };
  var onBlurSelf = function onBlurSelf() {
    setFocused(false);
    if (onBlur) {
      onBlur();
    }
  };
  var onChangeSelf = function onChangeSelf(e) {
    if ((value || value === '') && onChange) {
      // controlled
      onChange(e.target.value);
    } else {
      // uncontrolled
      setValue(e.target.value);
    }
  };
  var classes = classNames('ptr-editable-text', {
    disabled: disabled,
    empty: !(value || valueState),
    large: large,
    editing: editing,
    required: required,
    inverted: inverted,
    invisible: invisible
  });
  var renderValue = value || valueState || '';
  var style = {
    height: renderValue.length ? height : DEFAULT_HEIGHT
  };
  var renderMessage = function renderMessage() {
    return required && !(value || valueState) ? /*#__PURE__*/_jsx("div", {
      className: "ptr-editable-text-message",
      children: "Required field"
    }) : null;
  };
  if (!disabled) {
    var message = renderMessage();
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("textarea", {
        tabIndex: unfocusable ? -1 : 0,
        className: classes,
        style: style,
        ref: ref,
        value: renderValue,
        placeholder: placeholder,
        onFocus: onFocusSelf,
        onBlur: onBlurSelf,
        spellCheck: focused,
        onChange: onChangeSelf
      }), message]
    });
  } else {
    return /*#__PURE__*/_jsx("div", {
      className: classes,
      children: value || valueState || ''
    });
  }
};
EditableText.propTypes = {
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  unfocusable: PropTypes.bool,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  large: PropTypes.bool,
  editing: PropTypes.bool,
  inverted: PropTypes.bool,
  placeholder: PropTypes.string,
  invisible: PropTypes.bool
};
export default EditableText;